import { motion } from "framer-motion";
import { Music } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { FormData, songStyleOptions } from "../types";

interface StyleStepProps {
  formData: FormData;
  onChange: (field: keyof FormData, value: string) => void;
}

const StyleStep = ({ formData, onChange }: StyleStepProps) => {
  return (
    <motion.div
      key="style"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className="space-y-6"
    >
      <div className="text-center mb-8">
        <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
          <Music className="w-8 h-8 text-primary" />
        </div>
        <h2 className="font-heading text-2xl font-bold text-foreground mb-2">
          Song Style
        </h2>
        <p className="text-muted-foreground">
          Choose the musical genre for your song.
        </p>
      </div>

      <div className="space-y-4">
        <Label>Select one *</Label>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 max-h-80 overflow-y-auto pr-2">
          {songStyleOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange("songStyle", option.value)}
              className={`p-3 rounded-xl border-2 transition-all text-center ${
                formData.songStyle === option.value
                  ? "border-primary bg-primary/5"
                  : "border-border hover:border-primary/50"
              }`}
            >
              <span className="text-sm font-medium">{option.label}</span>
            </button>
          ))}
        </div>
      </div>

      {formData.songStyle === "other" && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          className="space-y-2"
        >
          <Label htmlFor="songStyleOther">Describe the style *</Label>
          <Input
            id="songStyleOther"
            placeholder="Describe your preferred musical style"
            value={formData.songStyleOther}
            onChange={(e) => onChange("songStyleOther", e.target.value)}
          />
        </motion.div>
      )}
    </motion.div>
  );
};

export default StyleStep;
